import { ReportStatus } from "../../../api/types";
import styles from "./StatusIcon.module.css";
import { readableStatus } from "./util";

type StatusIconProps = {
  status: ReportStatus;
};

export const colorForStatus = (status: ReportStatus): string => {
  switch (status) {
    case "bound":
      return "var(--blue-500)";
    case "declined":
      return "var(--bluegray-500)";
    case "quoted":
      return "var(--indigo-500)";
    case "lost":
      return "var(--red-500)";
    case "pre_underwriting_review":
      return "var(--yellow-500)";
    case "pending":
      return "var(--primary-500)";
    case "not_cleared_effective_date_too_far":
    case "not_cleared_incomplete_submission":
    case "not_cleared_out_of_appetite":
    case "not_cleared_prior_submission":
    case "not_cleared_unapproved_broker":
    case "not_cleared_low_tiv":
      return "var(--orange-500)";
    case "cleared":
      return "var(--teal-500)";
    case "indicated":
      return "var(--purple-500)";
    case "issued":
      return "var(--green-500)";
  }
};

export const iconForStatus = (status: ReportStatus): string => {
  switch (status) {
    case "bound":
      return "pi pi-lock";
    case "declined":
      return "pi pi-thumbs-down";
    case "quoted":
      return "pi pi-hourglass";
    case "lost":
      return "pi pi-times";
    case "pre_underwriting_review":
      return "pi pi-eye";
    case "pending":
      return "pi pi-spinner-dotted";
    case "not_cleared_effective_date_too_far":
    case "not_cleared_incomplete_submission":
    case "not_cleared_out_of_appetite":
    case "not_cleared_prior_submission":
    case "not_cleared_unapproved_broker":
    case "not_cleared_low_tiv":
      return "pi pi-trash";
    case "cleared":
      return "pi pi-verified";
    case "indicated":
      return "pi pi-send";
    case "issued":
      return "pi pi-file-check";
  }
};

export const StatusIcon: React.FC<StatusIconProps> = ({ status }) => {
  return (
    <div className={styles.container}>
      <i
        className={iconForStatus(status)}
        style={{
          color: colorForStatus(status),
        }}
      ></i>
      <span>{readableStatus(status)}</span>
    </div>
  );
};
